/** The parts of a form the gate uses, so it can be tested without a browser. */
export interface GateForm {
  checkValidity(): boolean;
  querySelector(selectors: string): { focus(): void } | null;
}

const INVALID_CONTROL = 'input:invalid, textarea:invalid, select:invalid';

/**
 * Runs `onValid` only when every field passes. Otherwise each invalid field shows its message
 * (checkValidity fires their `invalid` events) and the first one gets focus.
 */
export function gateSubmit(form: GateForm, onValid: () => void): boolean {
  if (!form.checkValidity()) {
    form.querySelector(INVALID_CONTROL)?.focus();
    return false;
  }
  onValid();
  return true;
}

/** Whether every control in the form is valid, without showing any message. */
export const isFormValid = (form: { elements: ArrayLike<unknown> }): boolean =>
  Array.from(form.elements).every(
    (el) => (el as { validity?: ValidityState }).validity?.valid !== false,
  );
